import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClient } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Main app
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// HTTP Api
import { AppHttpClient } from '@base-api/api.interceptor';
import { ApiInterceptor } from '@base-api/http.client.interceptor';
import { ApiRequestsService, ApiDeclarations } from '@base-api/api.gateway';

// Guards
import { AppGuards } from '@base-guards/index.declarations';

// Shared
import { SharedModule } from '@base-shared/shared.module';
import { HttpModules, FormModules } from '@base-shared/shared-bootstraps';
import { GlobalServices, BaseConfigService, ConfigService, SentryErrorHandler } from '@base-shared/services';

// External
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { ToastrComponent, ToastrOptions } from '@base-shared/components/toastr/toastr.config';
import { BaseViewComponent } from '@base-shared/components/base-view/base-view.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env/environment';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    BaseViewComponent,
    ToastrComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    HttpModules(),
    FormModules(),
    SharedModule,
    ToastrModule.forRoot(ToastrOptions),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AppGuards(),
    GlobalServices(),
    AppHttpClient,
    ApiDeclarations(),
    ApiRequestsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    // {
    //   provide: ErrorHandler,
    //   useClass: SentryErrorHandler
    // },
  ],
  entryComponents: [ToastrComponent],
  bootstrap: [AppComponent]
})
export class BaseAppModule {
  static forRoot(config: any): ModuleWithProviders {
    return {
      ngModule: BaseAppModule,
      providers: [
        BaseConfigService,
        {
          provide: ConfigService,
          useValue: config
        }
      ]
    };
  }
}
